"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.join.js");

var _escape = _interopRequireDefault(require("lodash/escape"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = {
  escape: _escape.default
};

var _default = function _default(obj) {
  var __t,
      __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '');
  }

  __p += '\n<div class="zotero-item-header-container">\n	';

  if (obj.data.itemType == 'book') {
    ;
    __p += '\n			<div class="zotero-item-header">\n				<h3 class="zotero-item-title">\n					';

    if (obj.item[obj.constants.VIEW_ONLINE_URL]) {
      ;
      __p += '\n						<a href="' + __e(obj.utils.sanitizeURL(obj.item[obj.constants.VIEW_ONLINE_URL])) + '" rel="nofollow">' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '</a> ';

      if (obj.item[obj.constants.HAS_PDF]) {
        ;
        __p += ' [PDF]';
      }

      ;
      __p += '\n					';
    } else {
      ;
      __p += '\n						' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '\n					';
    }

    ;
    __p += '\n				</h3>\n				<div class="zotero-item-subline">\n					';

    if (obj.data.publisher) {
      ;
      __p += '\n						' + __e(obj.data.publisher);

      if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
        ;
        __p += ', ';
      }

      ;
      __p += '\n					';
    }

    ;
    __p += '\n					';

    if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
      ;
      __p += '\n						' + __e(obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) + '\n					';
    }

    ;
    __p += '\n				</div>\n			</div>\n		';
  } else if (obj.data.itemType == 'thesis') {
    ;
    __p += '\n			<div class="zotero-item-header">\n				<h3 class="zotero-item-title">\n					';

    if (obj.item[obj.constants.VIEW_ONLINE_URL]) {
      ;
      __p += '\n						<a href="' + __e(obj.utils.sanitizeURL(obj.item[obj.constants.VIEW_ONLINE_URL])) + '" rel="nofollow">' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '</a> ';

      if (obj.item[obj.constants.HAS_PDF]) {
        ;
        __p += ' [PDF]';
      }

      ;
      __p += '\n					';
    } else {
      ;
      __p += '\n						' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '\n					';
    }

    ;
    __p += '\n				</h3>\n				<div class="zotero-item-subline">\n					';

    if (obj.data.university) {
      ;
      __p += '\n						' + __e(obj.data.university);

      if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
        ;
        __p += ', ';
      }

      ;
      __p += '\n					';
    }

    ;
    __p += '\n					';

    if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
      ;
      __p += '\n						' + __e(obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) + '\n					';
    }

    ;
    __p += '\n				</div>\n			</div>\n		';
  } else if (obj.data.itemType == 'journalArticle') {
    ;
    __p += '\n		<div class="zotero-item-header">\n			<h3 class="zotero-item-title">\n				';

    if (obj.item[obj.constants.VIEW_ONLINE_URL]) {
      ;
      __p += '\n					<a href="' + __e(obj.utils.sanitizeURL(obj.item[obj.constants.VIEW_ONLINE_URL])) + '" rel="nofollow">' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '</a> ';

      if (obj.item[obj.constants.HAS_PDF]) {
        ;
        __p += ' [PDF]';
      }

      ;
      __p += '\n				';
    } else {
      ;
      __p += '\n					' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '\n				';
    }

    ;
    __p += '\n			</h3>\n			<div class="zotero-item-subline">\n				';

    if (obj.data.publicationTitle) {
      ;
      __p += '\n					' + __e(obj.data.publicationTitle);

      if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
        ;
        __p += ', ';
      }

      ;
      __p += '\n				';
    } else if (obj.data.journalAbbreviation) {
      ;
      __p += '\n					' + __e(obj.data.journalAbbreviation);

      if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
        ;
        __p += ', ';
      }

      ;
      __p += '\n				';
    }

    ;
    __p += '\n				';

    if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
      ;
      __p += '\n					' + __e(obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) + '\n				';
    }

    ;
    __p += '\n			</div>\n		</div>\n	';
  } else if (obj.data.itemType == 'newspaperArticle' || obj.data.itemType == 'magazineArticle') {
    ;
    __p += '\n		<div class="zotero-item-header">\n			<h3 class="zotero-item-title">\n				';

    if (obj.item[obj.constants.VIEW_ONLINE_URL]) {
      ;
      __p += '\n					<a href="' + __e(obj.utils.sanitizeURL(obj.item[obj.constants.VIEW_ONLINE_URL])) + '" rel="nofollow">' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '</a> ';

      if (obj.item[obj.constants.HAS_PDF]) {
        ;
        __p += ' [PDF]';
      }

      ;
      __p += '\n				';
    } else {
      ;
      __p += '\n					' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '\n				';
    }

    ;
    __p += '\n			</h3>\n			<div class="zotero-item-subline">\n				';

    if (obj.data.publicationTitle) {
      ;
      __p += '\n					' + __e(obj.data.publicationTitle);

      if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
        ;
        __p += ', ';
      }

      ;
      __p += '\n				';
    }

    ;
    __p += '\n				';

    if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
      ;
      __p += '\n					' + __e(obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) + '\n				';
    }

    ;
    __p += '\n			</div>\n		</div>\n	';
  } else if (obj.data.itemType == 'blogPost') {
    ;
    __p += '\n		<div class="zotero-item-header">\n			<h3 class="zotero-item-title">\n				';

    if (obj.item[obj.constants.VIEW_ONLINE_URL]) {
      ;
      __p += '\n					<a href="' + __e(obj.utils.sanitizeURL(obj.item[obj.constants.VIEW_ONLINE_URL])) + '" rel="nofollow">' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '</a> ';

      if (obj.item[obj.constants.HAS_PDF]) {
        ;
        __p += ' [PDF]';
      }

      ;
      __p += '\n				';
    } else {
      ;
      __p += '\n					' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '\n				';
    }

    ;
    __p += '\n			</h3>\n			<div class="zotero-item-subline">\n				';

    if (obj.data.blogTitle) {
      ;
      __p += '\n					' + __e(obj.data.blogTitle);

      if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
        ;
        __p += ', ';
      }

      ;
      __p += '\n				';
    }

    ;
    __p += '\n				';

    if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
      ;
      __p += '\n					' + __e(obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) + '\n				';
    }

    ;
    __p += '\n			</div>\n		</div>\n	';
  } else {
    ;
    __p += '\n		<div class="zotero-item-header">\n			<h3 class="zotero-item-title">\n				';

    if (obj.item[obj.constants.VIEW_ONLINE_URL]) {
      ;
      __p += '\n					<a href="' + __e(obj.utils.sanitizeURL(obj.item[obj.constants.VIEW_ONLINE_URL])) + '" rel="nofollow">' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '</a> ';

      if (obj.item[obj.constants.HAS_PDF]) {
        ;
        __p += ' [PDF]';
      }

      ;
      __p += '\n				';
    } else {
      ;
      __p += '\n					' + ((__t = obj.utils.escapeFormattedValue(obj.data.title)) == null ? '' : __t) + '\n				';
    }

    ;
    __p += '\n			</h3>\n\n			';

    if (obj.data[obj.constants.AUTHORS_SYMBOL] || obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
      ;
      __p += '\n				<div class="zotero-item-subline">\n					';

      if (obj.data[obj.constants.AUTHORS_SYMBOL] && obj.data[obj.constants.AUTHORS_SYMBOL]['Author']) {
        ;
        __p += '\n						By ' + __e(obj.data[obj.constants.AUTHORS_SYMBOL]['Author'].join(' & '));

        if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
          ;
          __p += ', ';
        }

        ;
        __p += '\n					';
      }

      ;
      __p += '\n\n					';

      if (obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) {
        ;
        __p += '\n						' + __e(obj.data[obj.constants.FORMATTED_DATE_SYMBOL]) + '\n					';
      }

      ;
      __p += '\n				</div>\n			';
    }

    ;
    __p += '\n		</div>\n	';
  }

  ;
  __p += '\n</div>';
  return __p;
};

exports.default = _default;